import * as Yup from "yup";

export const contactUsValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Please enter your name."),
  email: Yup.string()
    .email("Please enter a valid e-mail!")
    .required("Please enter your e-mail!"),
  message: Yup.string().trim().required("Please send us your message."),
});
